// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ea88b2c3","833":"b5b8d22a","977":"020efcda"}[chunkId] + ".chunk.js";
};